import { useState } from "react"

import ConfirmationModal, {
  ModalInfo,
} from "components/Modals/ConfirmationModal"
import { fetchTaxonomyPatterns, toggleTaxonomyStatus } from "api/taxonomies"
//import { groupBy, prop } from "lodash/fp"
import { queryCache, useMutation, useQuery } from "react-query"

import { TaxonomiesAcrossMT } from "./TaxonomiesAcrossMT"
//import { TaxonomiesPerMT } from "./TaxonomiesPerMT"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { useParams } from "react-router-dom"
import { useSendFeedBack } from "components/FeedbackSnackbar"

export function AgencyClientTaxonomy() {
  const { t } = useI18n()
  const feedback = useSendFeedBack()
  const [modalInfo, setModalInfo] = useState<ModalInfo>(undefined)
  const { configId } = useParams<{ configId: string }>()

  // ** fetch taxonomy
  const { data: taxonomies, isLoading } = useQuery(
    ["taxonomy-patterns", configId],
    fetchTaxonomyPatterns,
  )

  // // ** fetch taxonomy fields
  // const { data: taxonomyFields, isLoading: isFieldsLoading } = useQuery(
  //   ["taxonomy-patterns/fields"],
  //   fetchTaxonomyFields,
  // )

  // const taxonomyBOFields = taxonomyFields
  //   ?.filter((tx) => tx.entityType === "BOOKING_ORDER")
  //   ?.map((tx) => tx.fields)

  const [toggle] = useMutation(toggleTaxonomyStatus, {
    onSuccess: () =>
      queryCache.invalidateQueries(["taxonomy-patterns", configId]),
    onError: (err) => {
      feedback(t(err.message), "error")
    },
  })

  const updateRow = (checked: boolean, id: string) => {
    toggle({ enabled: checked, id: id })
  }

  const taxonomiesAcrossAllMapped =
    taxonomies
      ?.filter((tx) => tx?.entityType === "BOOKING_ORDER")
      ?.map((tx) => ({
        id: tx?.id,
        clientAgencyConfigId: tx?.clientAgencyConfigId,
        entityType: tx?.entityType,
        enabled: tx?.enabled,
        content: tx?.content,
      })) || []

  //const bySemantic = groupBy(prop("mediaTypeSemantic"), taxonomies)

  // const txBySemantic = Object.fromEntries(
  //   Object.entries(bySemantic).filter(([key, _]) => key !== ""),
  // )

  const isModalOpen = Boolean(modalInfo)

  return (
    <div className={styles.container}>
      <>
        {!!taxonomies?.length && (
          <TaxonomiesAcrossMT
            taxonomies={taxonomiesAcrossAllMapped}
            updateRow={updateRow}
            loading={isLoading}
          />
        )}
        {/* <TaxonomiesPerMT
          txBySemantic={txBySemantic}
          updateRow={updateRow}
          loading={isLoading}
        /> */}
      </>
      <ConfirmationModal
        open={isModalOpen}
        onCancel={() => setModalInfo(undefined)}
        {...modalInfo}
      />
    </div>
  )
}

const styles = {
  container: css`
    padding: var(--spacing-xxl-2) 0px 0px 0px;
  `,
}
